import { Inject, Injectable, Optional } from "@angular/core";

declare var window: any;

@Injectable()
export class IncodeService {
  private sdkInitialized = false;

  incode: any;
  session: any;

  constructor(@Optional() @Inject("incode_api_url") private api_url: string) {}

  public async initialize(): Promise<boolean> {
    if (this.sdkInitialized) {
      return Promise.resolve(true); // Devuelve una promesa resuelta si el SDK ya está inicializado
    }

    try {
      this.incode = await this.startIncode();
      return Promise.resolve(true);
    } catch (e) {
      throw e;
      return Promise.resolve(false);
    }
  }
  private async startIncode() {
    // when included via script tag
    // Trial: override Incode CDN copy for low-quality selfie notification.
    // Keys: notifications.lowQualityImage / notifications.lowQualityImageDescription
    // If the SDK ignores partial translations, revert this block.
    const incodeConfig = {
      apiURL: this.api_url + "/0", // provided by Incode
      lang: "es",
      translations: {
        notifications: {
          lowQualityImage: "Mejora la calidad de tu selfie",
          lowQualityImageDescription:
            "Mantente quieto frente a la cámara. Tu rostro debe verse claro, completo y bien iluminado.",
        },
      },
    };
    let incodeObj = await window.OnBoarding.create(incodeConfig);
    // initialize() ensures custom translations load before capture modules (SDK >= 1.83)
    if (typeof incodeObj.initialize === "function") {
      await incodeObj.initialize();
    }
    await incodeObj.warmup();
    return incodeObj;
  }
}
